export const ENDPOINTS = {
  production: {
    http: 'https://api.tulka.com',
    ws: 'wss://ws.tulka.com',
    app: 'app.tulka.com',
    platform: 'https://prod-api-v2.tulka.com/',
    integration: 'https://integrations2.tulka.com',
    aiBackend: 'https://prod-ai-api.tulka.com/interpreter',
    oidc: 'https://extranet.tulka.com'
  },
  release: {
    http: 'https://release-api-v2.tulka.com/',
    ws: 'wss://release-ws.tulka.com',
    app: 'release-app.tulka.com',
    platform: 'https://release-api-v2.tulka.com/',
    integration: 'https://integrations.release.tulka.com',
    aiBackend: 'https://release-ai-api.tulka.com/interpreter',
    oidc: 'https://release-oidc.tulka.com'
  },
  staging: {
    http: 'https://staging-api-v2.tulka.com/',
    ws: 'wss://staging-ws.tulka.com',
    app: 'staging-app.tulka.com',
    platform: 'https://staging-api-v2.tulka.com/',
    integration: 'https://integrations.preprod.tulka.com',
    aiBackend: 'https://ca-reverse-proxy-preprodwp.bravecoast-fc45ce4d.swedencentral.azurecontainerapps.io/interpreter',
    oidc: 'https://staging-oidc.tulka.com'
  },
  pilot: {
    http: 'https://api.tulka.com',
    ws: 'wss://ws.tulka.com',
    app: 'newapp.tulka.com',
    platform: 'https://prod-api-v2.tulka.com/',
    integration: 'https://integrations2.tulka.com',
    oidc: 'https://extranet.tulka.com'
  },
  development: {
    http: 'https://preprod.tulka.com',
    ws: 'wss://preprod-ws.tulka.com',
    aiws: 'wss://ca-reverse-proxy-preprodwp.bravecoast-fc45ce4d.swedencentral.azurecontainerapps.io/interpreter',
    app: 'preprod-app.tulka.com',
    platform: 'https://preprod2-api-v2.tulka.com/',
    integration: 'https://integrations.preprod.tulka.com',
    // For some reason https://preprod-ai-api.tulka.com/interpreter is not working
    aiBackend: 'https://ca-reverse-proxy-preprodwp.bravecoast-fc45ce4d.swedencentral.azurecontainerapps.io/interpreter',
    oidc: 'https://preprod-oidc.tulka.com'
  }
};

const env = process.env.REACT_APP_ENV || 'development';
const ENDPOINT = ENDPOINTS[env];

export const getCurrentEnv = () => {
  if (window.location.host === ENDPOINTS.production.app) {
    return 'production';
  }
  if (window.location.host === ENDPOINTS.pilot.app) {
    return 'pilot';
  }
  if (window.location.host === ENDPOINTS.release.app) {
    return 'release';
  }
  if (window.location.host === ENDPOINTS.staging.app) {
    return 'staging';
  }
  return 'development';
};

export const URL = ENDPOINT.http;

export const WSURL = ENDPOINT.ws;

export const VERSION = '/api/v1';

export const PLATFORM = ENDPOINT.platform;

export const INTEGRATION = ENDPOINT.integration;

export const AI_BACKEND = ENDPOINT.aiBackend;

export const OIDC = ENDPOINT.oidc;

export const TULKA_INTERCOM_APP_ID = 'smdozk5z';
export const HEROTOLK_INTERCOM_APP_ID = 'ajltmpcf';
export const INTERCOM_EU_API_BASE = 'https://api-iam.eu.intercom.io';
